import { Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-clipboard',
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-2">
      <input
        type="text"
        [value]="text()"
        [readonly]="true"
        [class]="inputClasses"
        #textInput />
      <button
        type="button"
        (click)="copyToClipboard()"
        [class]="buttonClasses"
        [attr.aria-label]="'Copy to clipboard'">
        @if (copied()) {
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        } @else {
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        }
      </button>
    </div>
  `,
  styles: []
})
export class ClipboardComponent {
  text = input<string>('');

  copyEvent = output<string>();

  copied = signal(false);

  async copyToClipboard(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.text());
      this.copied.set(true);
      this.copyEvent.emit(this.text());
      setTimeout(() => this.copied.set(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }

  get inputClasses(): string {
    return 'flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-l-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none';
  }

  get buttonClasses(): string {
    return 'px-4 py-2 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors';
  }
}

